import { makeStyles, Theme } from '@material-ui/core';
import { colors } from '@lifesize/ux-assets';
import baseColors from 'styles/variables/baseColors.module.scss';

const muiSwitchStyles = makeStyles((theme: Theme) => ({
  switch: {
    width: '58px',
    height: 'auto',
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent'
      },
      '&.Mui-checked': {
        transform: 'translateX(18px)',
        color: theme.palette.common.white,
        '&+.MuiSwitch-track': {
          opacity: 1
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: colors.white
        }
      }
    },
    '& .MuiSwitch-thumb': {
      width: 15,
      height: 15,
      backgroundColor: baseColors.granite,
      margin: '3px 3px',
      boxShadow: 'none'
    },
    '& .MuiSwitch-track': {
      width: '40px',
      height: '21px',
      borderRadius: 38 / 2,
      border: `1px solid ${baseColors.granite}`,
      backgroundColor: colors.white,
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border'])
    }
  }
}));

export default muiSwitchStyles;
